import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlurService {
  private blurSubject = new BehaviorSubject<boolean>(false);
  public blurState$ = this.blurSubject.asObservable();

  /**
   * Enable blur effect on the entire screen
   */
  enableBlur(): void {
    console.log('BlurService: Enabling blur');
    this.blurSubject.next(true);
  }

  /**
   * Disable blur effect on the entire screen
   */
  disableBlur(): void {
    console.log('BlurService: Disabling blur');
    this.blurSubject.next(false);
  }

  /**
   * Toggle blur effect
   */
  toggleBlur(): void {
    this.blurSubject.next(!this.blurSubject.value);
  }

  /**
   * Get current blur state
   */
  get isBlurred(): boolean {
    return this.blurSubject.value;
  }
}
